import { useTranslation } from 'next-i18next';
import { formatEnglishTitleCase } from '@/utils';
import { ProfileTitleWithMenus } from '../share/ProfileTitleWithMenus';
import { ProfileEditContainer } from './ProfileEditContainer';
export const ProfileEditPage = () => {
  const {
    t,
    i18n
  } = useTranslation(['common']);
  return <>
      <ProfileTitleWithMenus title={<span className={'text-heading-xl-extrabold text-default'}>
            {formatEnglishTitleCase(t('common:detailProfile'), i18n.resolvedLanguage)}
          </span>} className={'mb-md py-xs'} hideMobileDropdown data-sentry-element="ProfileTitleWithMenus" data-sentry-source-file="ProfileEditPage.tsx" />
      <ProfileEditContainer data-sentry-element="ProfileEditContainer" data-sentry-source-file="ProfileEditPage.tsx" />
    </>;
};